import _Divider from './Divider';

import './style/index.js';

export type { DividerProps } from './Divider';
export * from './type';

export const Divider = _Divider;
export default Divider;
